import { PropsWithChildren } from "react";

export const NoteLayout = ({ children }: PropsWithChildren) => (
  <div className="flex w-full flex-col gap-3 rounded-lg border px-5 py-6 shadow-inner shadow-gray-50 transition-all duration-700">
    {children}
  </div>
);
